<template>
  <v-container>
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <static-page-content slug="contact" />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <contact-form />
      </v-flex>
      <featured-video />
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
export default {
  name: 'PageContact'
}
</script>



// WEBPACK FOOTER //
// src/pages/contact.vue